import { useEffect, createRef, useContext } from "react";
import { getUserCookie, GraphContext } from "./data";
// import { Viewer } from "../monstar/viewer";
// import { Color } from "molstar/lib/mol-util/color";

/*
all default values for Viewer.create's second parameter:

allowMajorPerformanceCaveat: false
collapseLeftPanel: false
collapseRightPanel: false
customFormats: [Array(2)]
disableAntialiasing: false
disabledExtensions: []
emdbProvider: "pdbe"
extensions: 
(17) ['volseg', 'backgrounds', 'dnatco-ntcs', 'pdbe-structure-quality-report', 'assembly-symmetry', 'rcsb-validation-report', 'anvil-membrane-orientation', 'g3d', 'model-export', 'mp4-export', 'geo-export', 'ma-quality-assessment', 'zenodo-import', 'sb-ncbr-partial-charges', 'wwpdb-chemical-component-dictionary', 'mvs', 'tunnels']
layoutControlsDisplay: "reactive"
layoutIsExpanded: true
layoutShowControls: true
layoutShowLeftPanel: true
layoutShowLog: true
layoutShowRemoteState: true
layoutShowSequence: true
pdbProvider: "pdbe"
pickScale: 0.25
pixelScale: 1
pluginStateServer: "https://webchem.ncbr.muni.cz/molstar-state"
powerPreference: "high-performance"
preferWebgl1: false
rcsbAssemblySymmetryApplyColors: true
rcsbAssemblySymmetryDefaultServerType: "rcsb"
rcsbAssemblySymmetryDefaultServerUrl: "https://data.rcsb.org/graphql"
saccharideCompIdMapType: "default"
transparency: "wboit"
viewportShowAnimation: true
viewportShowControls: true
viewportShowExpand: true
viewportShowSelectionMode: true
viewportShowSettings: true
viewportShowTrajectoryControls: true
volumeStreamingDisabled: false
volumeStreamingServer: "https://ds.litemol.org"
volumesAndSegmentationsDefaultServer: "http://localhost:9000/v2"
*/

let _saved: any = { plugin : null };
export function MolStarWrapper() {
  const parent = createRef<HTMLDivElement>();
  const { nodeData } = useContext(GraphContext);
  // console.log("node props:", nodeData);

  const loadData = async (dataId: string) => {
    // Remove previous structures
    await _saved.plugin.clear();

    const dom = document.querySelector(".msp-layout-region.msp-layout-main");
    const loginDom = document.querySelector(".login-message");
    const userCookie = getUserCookie();
    if (!userCookie) {
      if (dom && !loginDom) {
        const div = document.createElement("div");
        div.className = "login-message";
        div.innerHTML = "Please login";
        div.style.color = "red";
        div.style.fontSize = "20px";
        div.style.textAlign = "center";
        div.style.position = "absolute";
        div.style.top = "50%";
        div.style.left = "50%";
        div.style.transform = "translate(-50%, -50%)";
        dom.appendChild(div);
      }
      return;
    } else {
      if (loginDom) {
        loginDom.remove();
      }
    }

    try {
      // load data
      const data = await _saved.plugin.builders.data.download(
        // { url: "/data/pdb/" + dataId + ".pdb" },
        { url: "/api/pdb-data?id=" + dataId },
        { state: { isGhost: true } }
      );

      const trajectory = await _saved.plugin.builders.structure.parseTrajectory(
        data,
        "pdb"
      );
      const preset =
        await _saved.plugin.builders.structure.hierarchy.applyPreset(
          trajectory,
          "default"
        );
      const cartoon = preset.representation.representations.polymer;
      // console.log(cartoon);
      if (cartoon) {
        // const ty = _saved.plugin.representation.structure.registry.get("cartoon");
        // const colorTy = _saved.plugin.representation.structure.themes.colorThemeRegistry.get("uncertainty");
        // const sizeTy = _saved.plugin.representation.structure.themes.sizeThemeRegistry.get("uniform");
        const update = await _saved.plugin
          .build()
          .to(cartoon)
          .update({
            type: { name: "cartoon", params: undefined },
            colorTheme: {
              name: "uncertainty",
              params: {
                value: 0.5,
                domain: [0, 100],
                list: {
                  colors: [
                    0x673ab7,
                    0xffc107, // Yellow at the middle value
                    0xf44336,
                  ],
                }, // Blue at the highest value
              },
            },
            sizeTheme: { name: "uniform", params: undefined },
          });
        await update.commit();
      }
    } catch (e) {
      return;
    }
  };

  useEffect(() => {
    // // This version needs to load molstar js in index.html
    async function init2() {
      if (_saved.plugin) {
        loadData(nodeData["id"]);
        return;
      }
      if (!(window as any).molstar) {
        return;
      }
      const viewer = await (window as any).molstar.Viewer.create("molstar-component", {
        layoutIsExpanded: !1,
        layoutShowControls: !1,
        layoutShowRemoteState: !1,
        layoutShowSequence: !0,
        layoutShowLog: !1,
        layoutShowLeftPanel: !0,
        viewportShowExpand: !0,
        viewportShowSelectionMode: !1,
        viewportShowAnimation: !1,
        volumesAndSegmentationsDefaultServer: "/", // fake page
      });

      // console.log("viewer:", viewer);
      // Set background color
      viewer.plugin.canvas3d?.setProps({
        renderer: {
          backgroundColor: 0x030c1d,
        },
      });

      _saved.plugin = viewer.plugin;
      loadData(nodeData["id"]);
    }
    // async function init() {
    //   const viewer = await Viewer.create("molstar-component", {
    //     layoutIsExpanded: !1,
    //     layoutShowControls: !1,
    //     layoutShowRemoteState: !1,
    //     layoutShowSequence: !0,
    //     layoutShowLog: !1,
    //     layoutShowLeftPanel: !0,
    //     viewportShowExpand: !0,
    //     viewportShowSelectionMode: !1,
    //     viewportShowAnimation: !1,
    //     volumesAndSegmentationsDefaultServer: "/", // fake page
    //   });

    //   console.log("viewer:", viewer);
    //   // Set background color
    //   viewer.plugin.canvas3d?.setProps({
    //     renderer: {
    //       backgroundColor: Color(0x030c1d),
    //     },
    //   });

    //   plugin = viewer.plugin;
    //   loadData(nodeData["id"]);
    // }
    try {
      nodeData && nodeData["id"] && init2();
    } catch (e) {
      console.error(e);
    }
    return () => {};
  }, [nodeData && nodeData["id"]]);

  const display = !nodeData || !nodeData["id"] ? "none" : "block";
  return (
    <div
      id="molstar-component"
      ref={parent}
      style={{ display, width: "100%", height: 400, position: "relative" }}
    ></div>
  );
}
